module.exports = __webpack_public_path__ + "img/ealab_meetyourlab.7ddf21c7.png";